import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Container, Grid, Button, Typography } from '@mui/material';
import CircularLoader from 'Components/Loaders/CircularLoader';
import useGlobalState from 'Hooks/useGlobalState';
import mainStyles from 'Styles/mainStyles';
import { useTranslation } from 'react-i18next';

const ConfirmDevice = (props) => {
	const [state] = useGlobalState();
	const navigate = useNavigate();
	const location = useLocation();
	const classes = mainStyles();
	const { t } = useTranslation();

	useEffect(() => {
		console.log('ConfirmDevice - useEffect')
		// const fetchData = async () => {
		// 	let device = await getDeviceByUuname('skyen'+deviceId)
		// 	dispatch({ device: device });
		// }
		// fetchData();
		console.log(state.device, location)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handleConfirm = () => {
		navigate('installed')
	}
	return (state.device ? 
		<Container component="main" maxWidth="sm">
			<Grid container justifyContent={'center'} alignItems='center'>
				<div className={classes.onboardContainer}>
					<Typography variant="h4" className={classes.title}>{t('Er dette den rette sensor?')}</Typography>
				</div>
				<div className={classes.onboardImageContainer}>
					<img src="/assets/skyen.png" alt="Skyen" className={classes.onboardImageSkyen} />
				</div>
				<div className={classes.onboardContainer}>
					<Typography variant="h5" className={classes.title}>{t('Sensor')}</Typography>
				</div>
				<div className={classes.onboardContainer}>
					<Typography variant="body1" className={classes.title}>{state.device.uuname.toUpperCase()}</Typography>
				</div>
				<div className={classes.onboardContainer}>
					<Typography variant="body2" className={classes.title}>{t('Tryk på knappen "Bekræft" for at acceptere at dette er den scannede sensor og at du vil  forbinde dette produkt til platformen.')}</Typography>
				</div>

				<Button onClick={handleConfirm} variant="contained" className={classes.greenButton}>{t('Bekræft')}</Button>
			</Grid>
		</Container>
		:
		<CircularLoader />
	)

}

export default ConfirmDevice;